import React from 'react';
import styled from 'styled-components/macro';
import { ReactComponent as DuplicateIcon } from '../../../images/icons/copy.svg';
import { ReactComponent as DeleteIcon } from '../../../images/icons/delete.svg';
import { ReactComponent as BombIcon } from '../../../images/icons/bomb-solid.svg';
import { SecondaryButton } from '../../../shared/Button';
import { FadingMessage } from '../../../shared/FadingMessage';
import { spacing01, spacing02, spacing03, spacing04 } from '../../../styling/spacing';

type DeleteAndDuplicateButtonsProps = {
  onClickDelete: () => void;
  onClickDuplicate: () => void;
  deleteButtonTestId?: string;
  className?: string;
  disabled?: boolean;
  children?: React.ReactNode;
};

export const DeleteAndDuplicateButtons = ({
  onClickDelete,
  onClickDuplicate,
  deleteButtonTestId,
  className,
  disabled,
  children,
}: DeleteAndDuplicateButtonsProps) => (
  <Container className={className}>
    <IconButton onClick={onClickDelete} title="Delete" data-testid={deleteButtonTestId} disabled={disabled}>
      <DeleteIcon title="Delete" />
    </IconButton>
    <IconButton onClick={onClickDuplicate} title="Duplicate" disabled={disabled}>
      <DuplicateIcon title="Duplicate" />
    </IconButton>
    {children}
  </Container>
);

type DeleteButtonProps = {
  onClick: () => void;
  testId?: string;
  tooltipLabel?: string;
  icon?: 'Delete' | 'Bomb';
};

export const DeleteButton = ({ onClick, testId, tooltipLabel = 'Delete', icon = 'Delete' }: DeleteButtonProps) => (
  <Container>
    <IconButton onClick={onClick} title={tooltipLabel} data-testid={testId}>
      {icon === 'Delete' ? <DeleteIcon title={tooltipLabel} /> : <BombIcon title={tooltipLabel} />}
    </IconButton>
  </Container>
);

const Container = styled.div`
  margin-left: ${spacing03};
`;

export const IconButton = styled(SecondaryButton)`
  margin-left: ${spacing03};
  padding: ${spacing01} ${spacing02};
  height: 40px;

  svg {
    height: 80%;
  }
`;

export const DuplicatedSuccessMessage = styled(FadingMessage)`
  margin-left: ${spacing04};
`;
